module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA5.0ffd62a7.jpg";